<template>
    <div class="mt-5">
        <vx-card class="no-scroll-content" title="MasterFile Upload">
            <div class="w-full mt-5">
                      <div class="mb-8">
                          <import-excel :onSuccess="loadDataInTable" />
                      </div>
                      <vx-card v-if="tableData.length && header.length">
                          <vs-table stripe pagination :max-items="10" search :data="tableData">
                              <template slot="header">
                              <h4>{{ sheetName }}</h4>
                              </template>

                              <template slot="thead">
                              <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
                              </template>

                              <template slot-scope="{data}">
                              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                  <vs-td :data="col" v-for="(col, indexcol) in data[indextr]" :key="indexcol + col">
                                  {{ col }}
                                  </vs-td>
                              </vs-tr>
                              </template>
                          </vs-table>
                        <div class="vx-row">
                          <vs-row>
                            <vs-col class="mt-5" vs-offset="10" vs-tooltip="'col - 1'" vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
                              <vs-button @click="uploadData()" color="success" type="filled" icon-pack="feather" icon="icon-upload"> Upload</vs-button>
                            </vs-col>
                          </vs-row>
                        </div>
                      </vx-card>

                  </div>
            

        </vx-card>
    </div>
</template>


<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import ImportExcel from '@/components/excel/ImportExcel.vue'
import VxCard from '../../components/vx-card/VxCard.vue'
export default {
    data() {
        return {
            activeTab: 0,

            tableData               : [],
            header                  : [],
            sheetName               : '',
        }

    },
    methods: {
        loadDataInTable ({ results, header, meta }) {
        this.header = header
        this.tableData = results
        this.sheetName = meta.sheetName
        }
    },
    components: {
    TabContent,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    ImportExcel,
    VxCard,
   }
}
</script>